import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IAcaoPlanoAcaoEvidenciaAuditorModel, IAcaoPlanoAcaoEvidenciaModel, IAcaoPlanoAcaoHistoricoModel, IAcaoPlanoAcaoModel, IAcaoPlanoAcaoRecomendacaoModel, IPlanoAcaoModel } from "../../../models/plano-acao-model";
import { PlanoAcaoService } from "../../../services/plano-acao.service";
import Swal from "sweetalert2";
import { AuthService } from "./../../../services/auth.service";
import { BaseFormComponent } from "../../../shared/components/base-form/base-form.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { IEnumModel } from "../../../models/enum.model";
import { PlanoAcaoRecomendacaoComponent } from "../../plano-acao/plano-acao-form/plano-acao-recomendacao/plano-acao-recomendacao.component";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { angularEditorConfig } from "../../../shared/util/angularEditorConfig";
import { carregarAbasHistorico } from "../../../shared/util/plano-acao-historico-abas";

@Component({
  selector: 'app-plano-acao-monitor-monitorar-acao',
  templateUrl: './plano-acao-monitor-monitorar-acao.component.html',
  styleUrls: ['./plano-acao-monitor-monitorar-acao.component.scss']
})

export class PlanoAcaoMonitorMonitorarAcaoComponent extends BaseFormComponent implements OnInit {

  @ViewChild("tabelaRecomendacaoPaginator", { static: true })
  tabelaRecomendacaoPaginator: MatPaginator;
  @ViewChild("tabelaRecomendacaoSort", { static: true })
  tabelaRecomendacaoSort: MatSort;

  @ViewChild("tabelaEvidenciaPaginator", { static: true })
  tabelaEvidenciaPaginator: MatPaginator;
  @ViewChild("tabelaEvidenciaSort", { static: true })
  tabelaEvidenciaSort: MatSort;

  @ViewChild("tabelaEvidenciaAuditorPaginator", { static: true })
  tabelaEvidenciaAuditorPaginator: MatPaginator;
  @ViewChild("tabelaEvidenciaAuditorSort", { static: true })
  tabelaEvidenciaAuditorSort: MatSort;


  @ViewChild("maxLengthEditor") private angularEditor: any;

  public model = this.createModel();

  public dataSourceRecomendacao = new MatTableDataSource<IAcaoPlanoAcaoRecomendacaoModel>([]);
  public dataSourceEvidencia = new MatTableDataSource<IAcaoPlanoAcaoEvidenciaModel>([]);
  public dataSourceEvidenciaAuditor = new MatTableDataSource<IAcaoPlanoAcaoEvidenciaAuditorModel>([]);

  public tituloModal = "";
  public visualizar = false;
  public alterar = false;
  public id: number = 0;
  public planoAcaoId: number = 0;
  public unidadeGestoraId: number = 0;
  public osaExecucaoId: number = 0;
  public statusAtualDesc: string = '';
  public statusAtualCodigo: number = 0;


  public statusList = [
    { codigo: 9, descricao: "Atendida" },
    { codigo: 11, descricao: "Não Atendida" },
    { codigo: 10, descricao: "Atendida Parcialmente" },
    { codigo: 12, descricao: "Pendente de Ação de Controle" },
    { codigo: 13, descricao: "Não se Aplica" },
  ];

  public nivelRelevanciaList = [
    { codigo: 1, descricao: "Muito Baixa" },
    { codigo: 2, descricao: "Baixa" },
    { codigo: 3, descricao: "Moderada" },
    { codigo: 4, descricao: "Alta" },
    { codigo: 5, descricao: "Muito Alta" }
  ];

  public editorConfig: AngularEditorConfig = angularEditorConfig(
    "Digite a descrição",
    "180px",
    "100%"
  );

  public editorMaxLength = 1000;

  public maxFileSizeMB: number = 30;

  public acceptTypes: string = `
                  image/png,
                  image/jpeg,
                  application/pdf,
                  application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                  video/mp4
                `.replace(/\s/g, '');

  constructor(
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public router: Router,
    public localeService: BsLocaleService,
    public matDialog: MatDialog,
    public planoAcaoService: PlanoAcaoService,
    public authService: AuthService,
    private dialogRef: MatDialogRef<PlanoAcaoMonitorMonitorarAcaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    super(route, toastr, router, localeService, matDialog);

    this.id = data?.id;
    this.visualizar = data?.visualizar;
    this.alterar = data?.alterar;
    this.tituloModal = data?.titulo;
    this.planoAcaoId = data?.planoAcaoId;
    this.unidadeGestoraId = data?.unidadeGestoraId;
    this.osaExecucaoId = data?.osaExecucaoId;
    if (data?.element) {
      this.model = data?.element;
    }
  }

  // Demanda 68742 linha 41: ciclos anteriores (somente consulta).
  public historicos: IAcaoPlanoAcaoHistoricoModel[] = [];
  // Aba ativa = ciclo aberto (último sem avaliação); as demais são consulta readonly.
  public numeroAbaAtiva: number = 1;
  public historicosAnteriores: IAcaoPlanoAcaoHistoricoModel[] = [];
  public indiceAba = 0;

  ngOnInit(): void {

    if (this.id) {
      this.obter(this.id);
      this.carregarHistorico(this.id);
    }
  }

  public carregarHistorico(acaoId: number): void {
    carregarAbasHistorico((id) => this.planoAcaoService.obterHistoricoAcao(id), acaoId)
      .then((abas) => {
        this.historicos = abas.historicos;
        this.numeroAbaAtiva = abas.numeroAbaAtiva;
        this.historicosAnteriores = abas.historicosAnteriores;
        this.indiceAba = 0;
        // #region agent log
        fetch('http://127.0.0.1:7425/ingest/3db54933-b367-4436-8c45-2ac5d509e98a',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'6409f8'},body:JSON.stringify({sessionId:'6409f8',runId:'post-fix',hypothesisId:'F',location:'plano-acao-monitor-monitorar-acao.component.ts:carregarHistorico',message:'identificador da acao x ids de ciclo',data:{identificadorAcao:this.model?.identificador,idAcao:this.model?.id,idsCiclo:(abas.historicos||[]).map(h=>h.id),numeroAbaAtiva:abas.numeroAbaAtiva,anteriores:(abas.historicosAnteriores||[]).map(h=>h.numero)},timestamp:Date.now()})}).catch(()=>{});
        // #endregion
      });
  }

  public onAbaChange(indice: number): void {
    this.indiceAba = indice || 0;
    // #region agent log
    fetch('http://127.0.0.1:7425/ingest/3db54933-b367-4436-8c45-2ac5d509e98a',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'6409f8'},body:JSON.stringify({sessionId:'6409f8',runId:'post-fix',hypothesisId:'B',location:'plano-acao-monitor-monitorar-acao.component.ts:onAbaChange',message:'aba selecionada',data:{indice:this.indiceAba,salvarHabilitado:this.indiceAba===0&&!this.visualizar},timestamp:Date.now()})}).catch(()=>{});
    // #endregion
  }


  private createModel(): IAcaoPlanoAcaoModel {
    return {
      id: 0,
      planoAcaoId: this.planoAcaoId,
      planoAcao: {} as IPlanoAcaoModel,
      identificador: 0,
      titulo: '',
      descricao: '',
      responsavelId: '',
      responsavelNome: '',
      prazo: new Date,
      status: { codigo: 1, nome: 'Cadastrada', descricao: 'Cadastrada' } as IEnumModel,
      justificativaAvaliacao: '',
      nivelRelevancia: { codigo: 1, nome: 'MuitoBaixa', descricao: 'Muito Baixa' } as IEnumModel,
      comentarioAuditor: '',
      descricaoImplementacao: '',
      dataRealizacao: null,
      descricaoImplementacaoAuditor: '',
      avaliacao: null,
      dataMonitoramento: null,
      responsavelIdMonitoramento: '',
      responsavelNomeMonitoramento: '',
      responsavelCargoMonitoramento: '',
      recomendacoes: [],
      evidencias: [],
      evidenciasAuditor: []
    };
  }

  public obter(id: number) {

    this.planoAcaoService
      .obterAcaoPorId(id)
      .then((res) => {
        if (res.sucesso) {
          this.model = res.dados;
          this.model.prazo = new Date(this.model.prazo);
          this.statusAtualDesc = this.model.status.descricao;
          this.statusAtualCodigo = this.model.status.codigo;

          const statusPermitidos = [9, 10, 11, 12, 13];
          if (!statusPermitidos.includes(this.model.status.codigo)) {
            this.model.status = null;
          }

          if (this.model.dataRealizacao)
            this.model.dataRealizacao = new Date(this.model.dataRealizacao);

          this.dataSourceRecomendacao.data = this.model?.recomendacoes;
          this.dataSourceRecomendacao.paginator = this.tabelaRecomendacaoPaginator;
          this.dataSourceRecomendacao.sort = this.tabelaRecomendacaoSort;
          this.dataSourceRecomendacao.sortingDataAccessor = this.sortingDataAccessor;

          this.dataSourceEvidencia.data = this.model?.evidencias;
          this.dataSourceEvidencia.paginator = this.tabelaEvidenciaPaginator;
          this.dataSourceEvidencia.sort = this.tabelaEvidenciaSort;
          this.dataSourceEvidencia.sortingDataAccessor = this.sortingEvidenciaDataAccessor;

          this.dataSourceEvidenciaAuditor.data = this.model?.evidenciasAuditor;
          this.dataSourceEvidenciaAuditor.paginator = this.tabelaEvidenciaAuditorPaginator;
          this.dataSourceEvidenciaAuditor.sort = this.tabelaEvidenciaAuditorSort;
          this.dataSourceEvidenciaAuditor.sortingDataAccessor = this.sortingEvidenciaDataAccessor;

        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "titulo":
        return item.recomendacao.titulo;
      default:
        return item[property];
    }
  };

  public sortingEvidenciaDataAccessor = (item, property) => {
    switch (property) {
      case "nome":
        return item.evidencia.nome;
      default:
        return item[property];
    }
  };


  public modalRecomendacao(element?: IAcaoPlanoAcaoRecomendacaoModel) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-acao-recomendacao";
    dialogConfig.width = "50vw";
    dialogConfig.height = "45vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Visualizar Recomendação",
      element
    };

    const modal = this.matDialog.open(PlanoAcaoRecomendacaoComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
      }
    });
  }

  public salvar() {

    if (!this.model.nivelRelevancia) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "O campo Nível da Ação é Obrigatório!",
      });
      return;
    }

    if (!this.model.prazo) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "O campo Prazo de Implementação é Obrigatório!",
      });
      return;
    }

    if (!this.model.status) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "O campo Avaliação da Implementação pelo Auditor é Obrigatório!",
      });
      return;
    }

    if (!this.model.descricaoImplementacaoAuditor) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "O campo Descrição da Avaliação da Implementação pelo Auditor é obrigatório!",
      });
      return;
    }

    if (this.obterQuantidadeCaracteres(this.model.descricaoImplementacaoAuditor) > 1000) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "O campo Descrição da Avaliação da Implementação pelo Auditor tem um limite de 1000 caracteres e foi atingido, por favor ajuste!",
      });
      return;
    }

    //-> Monitorar a ação
    this.planoAcaoService
      .monitorarAcao(this.model)
      .then((res) => {
        if (res.sucesso) {

          this.dialogRef.close(true);

          Swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            icon: "success",
            text: res.mensagem.descricao,
          });
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  public fechar() {
    this.dialogRef.close();
  }

  public cancelar() {
    Swal.fire({
      title: "Cancelar",
      text: "Todas os dados não salvos serão perdidos. Deseja continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {
      if (res.value) {
        this.dialogRef.close();
      }
    });
  }

  ngAfterViewInit() {

    function maxLengthAngularEditor(e: any) {
      var element = e.target as HTMLTextAreaElement;
      let permitirTeclas =
        e.key !== "Backspace" &&
        e.key !== "ArrowLeft" &&
        e.key !== "ArrowRight";
      if (element.innerHTML.length === 1000 && permitirTeclas) {
        e.preventDefault();
      }
    }

    this.angularEditor?.textArea?.nativeElement.addEventListener(
      "keydown",
      maxLengthAngularEditor,
      false
    );
  }

  onEditorChange(content: string) {
    if (content.length > this.editorMaxLength) {
      // corta automaticamente para 1000 caracteres
      this.model.descricaoImplementacaoAuditor = content.substring(0, this.editorMaxLength);
    }
  }

  onEditorKeyDown(event: KeyboardEvent) {
    if (this.model.descricaoImplementacaoAuditor?.length >= this.editorMaxLength &&
      event.key !== 'Backspace' && event.key !== 'Delete') {
      event.preventDefault(); // bloqueia a digitação
    }
  }

  private obterQuantidadeCaracteres(html: string): number {

    if (!html) {
      return 0;
    }

    const div = document.createElement('div');
    div.innerHTML = html;

    const texto = (div.textContent || div.innerText || '')
      .replace(/\u00A0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return texto.length;
  }


  //#region Evidencias

  public async incluirEvidenciasAuditor(e: any) {

    const files = (e.target as HTMLInputElement).files;
    if (!files || files.length === 0) return;

    const maxBytes = this.maxFileSizeMB * 1024 * 1024;
    const acceptedTypes = this.acceptTypes.split(',').map(type => type.trim());

    const flatListFiles = Array.from(files);

    for (let i = 0; i < flatListFiles.length; i++) {

      const file = flatListFiles[i];

      // ✅ Validação de tamanho
      if (file.size > maxBytes) {
        alert(`O arquivo "${file.name}" excede o tamanho máximo de ${this.maxFileSizeMB} MB.`);
        continue;
      }

      // ✅ Validação de tipo
      if (!acceptedTypes.includes(file.type)) {
        alert(`O tipo do arquivo "${file.name}" (${file.type}) não é permitido. São permitidos apenas arquivos PNG, JPG, PDF, XLSX E MP4.`);
        continue;
      }

      const fileToArray = await this.getBase64(file);

      // adiciona na grade
      const novaEvidenciaAuditor: IAcaoPlanoAcaoEvidenciaAuditorModel = {
        id: 0,
        acaoId: this.id,
        acao: {} as IAcaoPlanoAcaoModel,
        tipo: file.type,
        nome: file.name,
        arquivo: fileToArray.toString(),
        link: ''
      };

      this.model.evidenciasAuditor.push(novaEvidenciaAuditor);
    }
    this.dataSourceEvidenciaAuditor.data = [...this.model.evidenciasAuditor];
  }

  public getBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text:
            "Ocorreu um erro ao selecionar o arquivo" +
            error.toString(),
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      };
    });
  }

  public excluirEvidenciaAuditor(index: number) {

    Swal.fire({
      title: "Excluir Evidência ?",
      text: "Confirma exclusão da Evidência?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.isConfirmed) {
        this.model.evidenciasAuditor?.splice(index, 1);
        this.dataSourceEvidenciaAuditor.data = [...this.model.evidenciasAuditor];
      }
    });
  }

  public Download(evidencia: IAcaoPlanoAcaoEvidenciaModel) {
    this.planoAcaoService.downloadEvidencia(evidencia.id).then((res) => {
      if (res.sucesso) {
        const link = document.createElement("a");
        link.href = res.dados.link.toString();
        link.download = res.dados.nome;
        link.click();
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    })
  }

  public DownloadAuditor(evidencia: IAcaoPlanoAcaoEvidenciaAuditorModel) {
    this.planoAcaoService.downloadEvidenciaAuditor(evidencia.id).then((res) => {
      if (res.sucesso) {
        const link = document.createElement("a");
        link.href = res.dados.link.toString();
        link.download = res.dados.nome;
        link.click();
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    })
  }
  //#endregion Evidencias

  podeEditarPrazo(): boolean {
    return this.statusAtualCodigo === 6 || this.statusAtualCodigo === 7;
  }

}


